import { MODAL_BLOCK_CONTENT_VIEW } from '@components/App/Modal/constants'
import { ProjectActions } from '@octopus-do/octopus-project-core'
import { SeoActions } from '@store/reducers/seo/actions'
import { commitProjectRequest } from '@storeOld/actionCreators'

import API from '@/api'
import { NotificationType, notificationActionCreators } from './notification'
import { openModal } from './ui'

export const uploadImage = (payload) => (dispatch, getState) => {
  const {
    manager: {
      meta: { id },
    },
  } = getState()

  return API.Image.upload({ projectId: id, ...payload })
    .then((response) => {
      dispatch(
        commitProjectRequest(
          ProjectActions.nodes.setImage({
            id: payload.nodeId,
            image: {
              id: response.id,
              imageUrl: response.imageUrl,
              thumbnailUrl: response.thumbnailUrl,
            },
          })
        )
      )

      return Promise.resolve(payload)
    })
    .catch(() => {
      dispatch(
        notificationActionCreators.setNotification({
          type: NotificationType.UPLOAD_ERROR,
        })
      )

      setTimeout(() => {
        dispatch(
          notificationActionCreators.setClearNotification({
            toastContainerId: 'main',
          })
        )
      }, 3000)
    })
}

export const deleteFigmaImage = (nodeId) =>
  commitProjectRequest(ProjectActions.nodes.deleteFigmaPreview({ id: nodeId }))

export const openSeoTags = (payload) => (dispatch, getState) => {
  // @todo implement selector
  const state = getState()
  const tree = Object.fromEntries(
    state.manager.project.nodes.map((item) => [item.id, item])
  )

  if (!tree[payload]) {
    return
  }

  dispatch(SeoActions.enableMode())
  dispatch(SeoActions.show(payload))
}

export const openNodeContent = (id) => (dispatch, getState) => {
  // @todo implement selector
  const state = getState()
  const tree = Object.fromEntries(
    state.manager.project.nodes.map((item) => [item.id, item])
  )

  if (!tree[id]) {
    return
  }

  dispatch(openModal(MODAL_BLOCK_CONTENT_VIEW, { nodeId: id, scrolless: true }))
}
